module.exports = __webpack_public_path__ + "img/Bulles_de_savon.e971929.jpg";